module.exports = __webpack_public_path__ + "static/img/ban-2.1f03ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-2.png
// module id = r0wi
// module chunks = 0